/* eslint-disable i18next/no-literal-string */
"use client";
import { Fragment } from "react";

import { Waveform } from "./Waveform";

export function Timeline({ embeddedInBlock = false }: { embeddedInBlock?: boolean }) {
  // Generate time markers from 0:00 to 1:30 with 10-second intervals
  const timeMarkers = [];
  for (let seconds = 0; seconds <= 90; seconds += 10) {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    timeMarkers.push({
      time: `${minutes}:${remainingSeconds.toString().padStart(2, "0")}`,
      seconds,
    });
  }

  return (
    <div className='relative w-full overflow-hidden'>
      {/* Timeline markers */}
      <div className='relative flex items-center justify-between gap-8 pt-2'>
        {timeMarkers.map((marker, index) => (
          <Fragment key={index}>
            {index !== 0 && <div className='h-3 w-3 shrink-0 rounded-full bg-overlay-darker-plus' />}
            <span className='f-paragraph-04 shrink-0 text-overlay-darker-plus'>{marker.time}</span>
          </Fragment>
        ))}
      </div>
      <div
        className='absolute bottom-0 right-0 h-full w-32'
        style={{
          background: embeddedInBlock
            ? "linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, #FFFFFF 100%)"
            : "linear-gradient(90deg, rgba(245, 243, 241, 0.00) 0%, #F5F3F1 100%)",
        }}
      />
    </div>
  );
}

export function LeftPanel({ isLoading }: { isLoading: boolean }) {
  const variation = {
    sections: [
      { title: "Intro", size: "30%" },
      { title: "Verse", size: "70%" },
    ],
    styles: {
      positive: ["Techno", "Minimal", "Synthwave", "Tribal", "Syth"],
      negative: ["Pop", "Heavy distortion", "Gritty vocals"],
    },
  };

  return (
    <div>
      {/* Static sections - no animations */}
      <div>
        <div className='mb-32 flex gap-8 px-16 py-8 md:px-20 xl:px-40'>
          {variation.sections.map((section, index) => (
            <div className='flex flex-col gap-8' key={index} style={{ width: section.size }}>
              <Waveform isLoading={isLoading} seed={`${index}`} />
              <div className='f-paragraph-04 truncate rounded-md border border-overlay-darker px-10 py-8 text-overlay-darker-plus md:f-paragraph-03 md:rounded-lg md:px-16 md:py-12'>
                {section.title}
              </div>
            </div>
          ))}
        </div>

        <div className='px-16 md:px-20 xl:px-40'>
          <p className='f-paragraph-04 mb-12 text-overlay-darker-plus md:f-paragraph-03'>Styles to include:</p>
          <div className='mb-16 flex flex-wrap gap-6'>
            {variation.styles.positive.map((style, index) => (
              <p
                className='f-paragraph-04 rounded-full border border-overlay-darker px-8 py-2 text-overlay-darker-plus md:f-paragraph-03 md:px-10 md:py-4'
                key={style}
              >
                {style}
              </p>
            ))}
          </div>
          <p className='f-paragraph-03 mb-12 text-overlay-darker-plus'>Styles to exclude:</p>
          <div className='flex flex-wrap gap-6'>
            {variation.styles.negative.map((style, index) => (
              <p
                className='f-paragraph-04 rounded-full border border-overlay-darker px-8 py-2 text-overlay-darker-plus md:f-paragraph-03 md:px-10 md:py-4'
                key={style}
              >
                {style}
              </p>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
